import { Platform } from "@ionic/angular";
import { WawiConnectorExecutable, WawiConnectorType, WawiConnectorTypeExecutable } from "../wawi-connector.types";
import { AppAvailability } from "@awesome-cordova-plugins/app-availability/ngx";
import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";

export class WawitogoAppConnectorService implements WawiConnectorExecutable{

    public type: WawiConnectorTypeExecutable = WawiConnectorType.WAWITOGO_APP;

    public executable: true = true;
    public static readonly WAWITOGO_SCHEME: string = "wawitogo://";
    public static IOS_PACKAGE_ID: string = "de.afssoftware.wawi-togo";

    constructor(){}

    public static async isAvailable(platform: Platform, appAvailability: AppAvailability): Promise<boolean> {
        return await appAvailability.check( platform.is("ios") ? WawitogoAppConnectorService.WAWITOGO_SCHEME : WawitogoAppConnectorService.IOS_PACKAGE_ID)
    }
    
    public executeCommand(command: string): Promise<HttpFunctionResult> {
        const url: string = `${WawitogoAppConnectorService.WAWITOGO_SCHEME}${command}`;
        window.open(url, "_system")
        return Promise.resolve({ success: true });
    }
    
    public openArticle(articleId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/article/id/${articleId}`)
    }

    public openCustomer(customerId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/address/id/${customerId}`)
    }
    
    public openProcess(processId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/order/id/${processId}`)
    }

}